// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"906cf5ad","453":"0b0194d6","455":"57548696"}[chunkId] + ".chunk.js";
};